<template>
  <div id="app">
    <!-- 表格区域 -->
    <el-table
      :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
      border
      :row-style="{ height: '48px' }"
      
      :data="typeLists"
      stripe
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="restypeName"
        label="资源类型"
        width="240"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="restypeNames"
        label="自定义资源名称"
        width="240"
      >
      </el-table-column>
      <el-table-column align="center" prop="restypeDescribes" label="资源描述">
        <template slot-scope="scope">
          <span v-if="scope.row.restypeStatus">{{
            scope.row.restypeDescribes
          }}</span>
          <span v-else>{{ scope.row.restypeDescribe }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="restypeMime" label="支持格式">
      </el-table-column>
      <el-table-column align="center" prop="restypeMime" label="是否启用">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.restypeStatus"
            @change="flagRes(scope.row)"
            active-color="#13ce66"
            inactive-color="#E9E9E9"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="restypeMime" label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.restypeStatus"
            @click="editorData(scope.row)"
            type="text"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog width="500px" title="编辑" :visible.sync="dialogFormVisible">
      <el-form label-width="120px">
        <el-form-item required label="资源名称：">
          <el-input
            style="width: 300px"
            v-model.trim="restypeName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item required label="资源描述：">
          <el-input
            style="width: 300px"
            v-model.trim="restypeDescribe"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="resTypes"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as homeApi from "@/api/home";
import { ERR_OK } from "@/api/index";
export default {
  data() {
    return {
      groupId: localStorage.getItem("groupId"),
      typeList: [],
      typeLists: [],
      dialogFormVisible: false,
      restypeName: "",
      restypeDescribe: "",
      resId: 0,
    };
  },
  created() {
    this.getResTypeList();
  },
  methods: {
    //   获取集团校资源类型列表
    getResTypeList() {
      let params = {
        schoolId: this.groupId,
        restypeBelong: 2,
      };
      homeApi.getResTypeList(params).then((res) => {
        this.typeList = res.data.data;
        this.getResTypeLists();
      });
    },
    // 获取系统资源列表
    getResTypeLists() {
      let params = {
        schoolId: 0,
        restypeBelong: 0,
      };
      homeApi.getResTypeList(params).then((res) => {
        let date = res.data.data;
        date.forEach((item) => {
          item.restypeStatus = false;
          this.typeList.forEach((items) => {
            if (item.restypeId == items.restypeId) {
              item.restypeStatus = true;
              item.restypeNames = items.restypeName;
              item.typesId = items.id;
              item.restypeDescribes = items.restypeDescribe;
            }
          });
        });
        this.typeLists = date;
      });
    },
    // 编辑信息
    editorData(row) {
      let restypeName = row.restypeNames;
      let restypeDescribe = row.restypeDescribes;
      this.restypeName = restypeName;
      this.restypeDescribe = restypeDescribe;
      this.dialogFormVisible = true;
      this.resId = row.typesId;
    },
    clear() {
      this.restypeDescribe = "";
      this.restypeName = "";
      this.resId = 0;
    },
    // 提交信息
    resTypes() {
      let params = {};
      if (this.resId !== 0) {
        params = {
          id: this.resId,
          restypeDescribe: this.restypeDescribe,
          restypeName: this.restypeName,
        };
      } else {
        params = {
          ...this.formData,
          schoolId: this.groupId,
          restypeBelong: 2,
        };
      }
      homeApi.resTypes(params).then((res) => {
        if (res.data.code == 0) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
        } else {
          this.$message.error(res.data.msg);
        }
        this.dialogFormVisible = false;
        this.clear();
        this.getResTypeList();
      });
    },
    // 是否启用
    flagRes(row) {
      if (row.restypeStatus) {
        delete row.id;
        row.restypeStatus = 1;
        this.formData = row;
        this.resTypes();
      } else {
        this.deleteResTypes(row.typesId);
      }
    },
    deleteResTypes(id) {
      homeApi.deleteResTypes({ id: id }).then((res) => {
        if (res.data.code == 0) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
        } else {
          this.$message.error(res.data.msg);
        }
        this.getResTypeList();
      });
    },
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/resources/setup.vue